import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '@/assets/img/singlecover.svg';
var _hoisted_1 = {
  class: "relative w-80 h-80 rounded-full border-8 border-gray-200"
};

var _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  class: "w-full absolute top-0 left-0",
  src: _imports_0
}, null, -1
/* HOISTED */
);

var _hoisted_3 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("img", {
    class: _normalizeClass(["absolute top-[51px] left-[52px] w-[200px] rounded-full", {
      'animate-spin-30': !$setup.isPause
    }]),
    src: $props.img
  }, null, 10
  /* CLASS, PROPS */
  , _hoisted_3)]);
}